import { getToken } from "@/lib/api";
import { toast } from "sonner";

/**
 * Download a file from a backend path with bearer-token auth.
 * Fetches a blob, then triggers a save via <a href=blobUrl download>.
 * Reports a clear toast on failure.
 */
export async function downloadFile(path, filename) {
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
  const url = `${base}/api${path.startsWith("/") ? path : "/" + path}`;
  const token = getToken();
  let toastId;
  try {
    toastId = toast.loading(`Preparing ${filename}…`);
    const res = await fetch(url, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw Object.assign(new Error(`Download failed (${res.status})${txt ? ": " + txt.slice(0, 120) : ""}`), { status: res.status });
    }
    const blob = await res.blob();
    if (blob.size === 0) throw new Error("Empty file returned by server.");
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    a.rel = "noopener";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    }, 2000);
    toast.success(`${filename} downloaded`, { id: toastId });
  } catch (err) {
    const msg = err?.status === 400 ? "No records available — try a different year or category."
      : err?.status === 401 ? "Please sign in again to download."
      : err?.status === 402 ? "This download requires an active subscription."
      : err?.status === 403 ? "You don't have permission to download this."
      : err?.status === 404 ? "File not found on the server."
      : err?.message || "Download failed.";
    toast.error(msg, { id: toastId });
    throw err;
  }
}
